// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"8fb0cb9c","787":"83e311c9"}[chunkId] + ".chunk.js";
};